import $ from 'jquery';
import {
  pushGA4Event,
  pushEvent,
  pushEventNonInteraction,
  pushInformation,
  addGAParam,
  calculateElementPosition,
  getFullUrl,
  getURLParameter,
  getFooterName,
  getHeaderName,
  getThemeName,
  getBMType,
  fireEvent,
  checkIntegratedDatalayerEnabled,
  getPossibleProductIDFromBookingLink
} from './helpers';
import { TVSEventListener } from './helpers-tvs';
import { GMSFormEventListener } from './helpers-gms-form';

window.ga4_events_template = true;

const EventTracking = {
  init(initSettings = {}) {
    const { extraBE = [], BIDnumber = '' } = initSettings;

    EventTracking.bookingEnginesRegEx =
      '(' + ['ihotelier.com', 'reservations.travelclick.com', ...extraBE].join('|') + ')';
    EventTracking.bookingEnginesWithoutAnalyticsParamRegEx = '(' + ['reservhotel.com'].join('|') + ')';
    EventTracking.setPageInfo();
    EventTracking.handleThemeEvents();
    EventTracking.handleDelphiDirectEvents();
    EventTracking.handleGMSEvents();
    EventTracking.handleGMSFormEvents();
    EventTracking.handleTVSEvents();
    EventTracking.handlePersonalizationPopupEvents();
    EventTracking.addThemeInformation(BIDnumber);
    EventTracking.addThemeEvents();
    EventTracking.signalInit();
  },
  setPageInfo() {
    this.separator = ' _ ';
    this.pageName = document.location.pathname + document.location.hash;
    this.pageSection = $('html').data('template');
    this.pageSectionAndName = this.pageSection + this.separator + this.pageName;
    this.pagePathURL = document.location.origin;
  },
  addThemeInformation(BIDnumber) {
    if (typeof dataLayer == 'undefined') return;
    if (checkIntegratedDatalayerEnabled()) return;

    const info = {
      event: 'datalayer-pre-render',
      fullURL: getFullUrl(),
      header: getHeaderName(),
      footer: getFooterName(),
      templateUsed: getThemeName()
    };
    dataLayer.push(info);
  },
  addThemeEvents() {
    const $document = $(document);
    var self = this;

    $document
      .on('click', 'a[href*="mailto:"]', function () {
        $document.trigger('event.emailing', $(this));
      })
      .on('click', 'a[href*="tel:"]', function () {
        $document.trigger('event.phoneCall', $(this));
      })
      .on('click', 'a[href*="whatsapp:"],a[href*="https://wa.me/"]', function () {
        $document.trigger('event.whatsappCall');
      })
      .on('click', 'a[href*=".pdf"]', function () {
        $document.trigger('event.download', $(this));
      })
      .on('click', 'a', function () {
        if (
          this.href.match(EventTracking.bookingEnginesRegEx) !== null &&
          this.href.match(/.pdf|tel:|mailto:/g) === null
        ) {
          //Adding _ga parameter only to BE links that need it.
          if (!this.href.match(EventTracking.bookingEnginesWithoutAnalyticsParamRegEx)) {
            addGAParam(this);
          }

          if ($(this).is('.js-galaxy-book-now-gms')) {
            $document.trigger('event.clickToBE.loyaltyProgramPrivateOffers', $(this));
          } else if ($(this).is('.js-galaxy-book-gms')) {
            $document.trigger('event.clickToBE.loyaltyProgramGeneralDashboard', $(this));
          } else if ($(this).is('.js-galaxy-book-again-gms')) {
            $document.trigger('event.clickToBE.loyaltyProgramBookAgain', $(this));
          } else if ($(this).is('.js-galaxy-modify-booking-gms')) {
            $document.trigger('event.clickToBE.loyaltyProgramModifyBooking', $(this));
          } else if ($(this).is('.js-galaxy-book-body,.js-dynamic-book-url,.js-map-infowindow')) {
            if ($(this).parents('.gm-style').length) {
              $document.trigger('event.clickToBE.bookOnMaps', $(this));
            } else {
              if(!$(this).is('.js-bm-rate__link')){
                $document.trigger('event.clickToBE.bookNowBodyButton', $(this));
              }
            }
          } else if (!$(this).is('.js-bm-rate__link')) {
            $document.trigger('event.clickToBE.bookNowLink', $(this));
          }
        } else {
          if (this.href.match(/maps.google/g) !== null || this.href.match(/google(.)*maps/g) !== null) {
            $document.trigger('event.contact', $(this));
          } else if ($(this).parents('.gms-form-auth__outro').length) {
            document.dispatchEvent(
              new CustomEvent('event.loyaltyProgram.registerStep1', {
                detail: $(this)
              })
            );
          } else if (
            $(this).parents('.m-footer-base_1--bottomSocials').length ||
            $(this).parents('.page-footer__socials').length ||
            $(this).parents('.social-media-wrapper').length
          ) {
            $document.trigger('event.externalLinks', $(this));
          } else if ($(this).parents('.language-switcher-dropdown').length) {
            $document.trigger('event.userBehavior.language', $(this));
          } else if ($(this).parents('footer').length) {
            $document.trigger('event.userBehavior.clicksOnFooterLinks', $(this));
          }
        }
      })
      .on('click', '.back-to-top', function () {
        $document.trigger('event.userBehavior.backToTop', $(this));
      })
      .on('click', '#header__wrapper-link', function () {
        $document.trigger('event.userBehavior.clicksOnLogo', $(this));
      })
      .on('click', '.js-et-click-on-logo', function () {
        $document.trigger('event.userBehavior.clicksOnLogo', $(this));
      })
      .on('click', '.module-nav__group--prev-next a', function () {
        $document.trigger('event.userBehavior.detailPageNavigation', $(this));
      })
      .on('click', '.js-btn-booking-mask-submit, #booking-mask-submit', function () {
        let $bmForm = $document.find('.js-booking-mask-form');
        if ($bmForm.length) {
          if (!$bmForm[0].checkValidity() || ($('#booking-mask-hotel').length && !$('#booking-mask-hotel').val().length)) {
            $document.trigger('event.error.clickToBE');
          }
        }
      })
      .on('click', '.gms-sso-btn', function () {
        const isLogin = $(this).closest('#gms-form-login').length === 1;
        const isSignUp = $(this).closest('#gms-form-sign-up').length === 1;
        if (isLogin) {
          document.dispatchEvent(new CustomEvent('event.loyaltyProgram.login', { detail: $(this) }));
        }
        if (isSignUp) {
          document.dispatchEvent(
            new CustomEvent('event.loyaltyProgram.registerStep2', {
              detail: $(this)
            })
          );
        }
      })
      .on('submit', '.newsletter-1step-form', function () {
        $document.trigger('event.newsletter.newSubscriber');
      })
      .on('click', '.gms-offer .btn', function () {
        $document.trigger('event.clickToBE.loyaltyProgramPrivateOffers', $(this));
      })
      .on('click', '.js-trigger-open-collapse', function () {
        fireEvent('event.userBehavior.collapseBM', $(this));
      });

    if (self.pageSection == '404') {
      $document.trigger('event.404');
    }
  },
  handleThemeEvents() {
    const $document = $(document);
    let self = this;

    document.addEventListener(
      'event.userBehavior.checkLocalAttractions',
      function (e) {
        let msg = {
          category: 'user_behavior',
          action: 'check_local_attractions',
          label: 'Clicked on:' + self.pageSectionAndName
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'check local attractions' }
        });
      },
      false
    );

    document.addEventListener(
      'event.clickToBE.bookOnMaps',
      function (e) {
        let $el = $(e.detail);
        let msg = {
          category: 'Click to BE',
          action: 'Book On Maps',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };

        pushEvent(msg);
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: { link_location: 'maps' }
        });
      },
      false
    );

    document.addEventListener(
      'event.error.formSubmission',
      function (e) {
        let el = e.detail,
          errors = '';
        Object.keys(el).forEach((item) => {
          errors = errors + item + ' ' + el[item] + ' ';
        });
        let msg = {
          category: 'Error',
          action: 'Form Submission',
          label: ['Submitted on:' + self.pageSectionAndName, 'error: ' + errors.trim()].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'form submission' } });
      },
      false
    );

    document.addEventListener(
      'event.formSubmission',
      function (e) {
        let msg = {
          category: 'Form submission',
          action: 'Generic form',
          label: 'Submitted on:' + self.pageSectionAndName
        };
        if (self.pageSection === 'contact-us') {
          msg.action = 'Contact form';
        }
        switch (e.detail) {
          case 'RFP':
            msg.action = 'RFP form';
            break;
          case 'Contact':
            msg.action = 'Contact form';
            break;
          case 'Newsletter':
            msg.category = 'Newsletter';
            msg.action = 'New Subscriber';
            msg.label = 'Submit Step 2';
            break;
        }
        pushEvent(msg);

        let isNewsletterBol = e.detail === 'Newsletter';
        if (isNewsletterBol) {
          pushGA4Event({ eventName: 'newsletter_subscription_complete' });
          return;
        }

        let formType = 'generic';
        if (e.detail === 'RFP') {
          formType = 'rfp';
        } else if (e.detail === 'Contact') {
          formType = 'contact';
        }

        pushGA4Event({
          eventName: 'contact',
          eventData: {
            method: 'form',
            form_type: formType
          }
        });
      },
      false
    );

    document.addEventListener(
      'event.clickToBE.bookNowLink',
      function (e) {
        let $el = $(e.detail);
        let msg = {
          category: 'Click to BE',
          action: 'Book Now Link',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);

        let productInfo = getPossibleProductIDFromBookingLink($el.attr('href'));
        if (productInfo) {
          pushGA4Event({
            eventName: 'click_to_booking_engine',
            eventData: {
              link_location: `book now ${productInfo.label}`,
              product_id: productInfo.product_id
            }
          });
          return;
        }
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'book now link'
          }
        });
      },
      false
    );

    document.addEventListener(
      'event.information',
      function (e) {
        let el = e.detail;
        pushInformation(el.name, el.value);
      },
      false
    );

    document.addEventListener(
      'event.userBehavior.collapseBM',
      function (e) {
        let $el = $(e.detail);
        let msg = {
          category: 'user_behavior',
          action: 'open_collapsed_booking_mask',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'open collapsed booking mask' }
        });
      },
      false
    );

    document.addEventListener(
      'event.bookingIntention',
      function (e) {
        let el = e.detail;
        let msg = {
          category: 'Booking Intention',
          action: el.dateIn + ' - ' + el.dateOut,
          label: [
            'num. nights:' + el.nights,
            el.adults + 'ad',
            el.rooms + 'r',
            el.children + 'ch',
            el.promocode + '-code'
          ].join(self.separator)
        };
        pushEvent(msg);
      },
      false
    );

    document.addEventListener(
      'event.clickToBE.bookingMask',
      function (e) {
        let msg = {
          category: 'Click to BE',
          action: 'Booking Mask',
          label: window.scrollY || window.pageYOffset ? 'Scrolled' : 'Default'
        };
        pushEvent(msg);

        const calendarRatesStr = () => {
          if (typeof bm_ui_settings === 'undefined') return 'no';
          return bm_ui_settings?.calendars?.ratesInCalendar?.enabled ? 'yes' : 'no';
        };

        const leadRateAvailability = () => {
          if (typeof bm_ui_settings === 'undefined') return 'no';
          return bm_ui_settings?.showRates && bm_ui_settings?.leadRates?.rate !== '' ? 'yes' : 'no';
        };

        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'booking mask',
            clicked: window.scrollY || window.pageYOffset ? 'scrolled' : 'default',
            booking_mask_type: getBMType(),
            calendar_rates: calendarRatesStr(),
            lead_rate_available: leadRateAvailability()
          }
        });
      },
      false
    );

    document.addEventListener(
      'event.clickToBE.leadRate',
      function (e) {
        let $el = $(e.detail);
        let msg = {
          category: 'Click to BE',
          action: 'Best Rate Link',
          label: ['Booked on:' + self.pageSectionAndName, $el.text().trim() || 'not_applicable'].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'best rate link'
          }
        });
      },
      false
    );

    document.addEventListener(
      'event.modifyBooking',
      function (e) {
        let $el = $(e.detail);
        let msg = {
          category: 'Modify booking',
          action: 'Link Modify Reservation',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'modify reservation link click' }
        });
      },
      false
    );

    document.addEventListener(
      'event.newsletter.newSubscriber',
      () => {
        $document.trigger('event.newsletter.newSubscriber');
      },
      false
    );

    document.addEventListener(
      'event.userBehavior.backToTop',
      (e) => {
        $document.trigger('event.userBehavior.backToTop', e.detail);
      },
      false
    );

    document.addEventListener('event.userBehavior.language', () => {}, false);

    $document
      .on('event.404', function (e) {
        let msg = {
          category: 'Error',
          action: 'Not found 404',
          label: self.pageName
        };
        pushEventNonInteraction(msg);
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'not found 404' } });
      })
      .on('event.emailing', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Emailing',
          action: 'Click mail to: ' + $el.attr('href').replace('mailto:', ''),
          label: ['Clicked on: ' + self.pageSectionAndName, calculateElementPosition($el)].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'contact',
          eventData: {
            method: 'email'
          }
        });
      })
      .on('event.phoneCall', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Phone Call',
          action: 'Click tel: ' + $el.attr('href').replace('tel:', ''),
          label: ['Clicked on: ' + self.pageSectionAndName, calculateElementPosition($el)].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'contact',
          eventData: {
            method: 'phone'
          }
        });
      })
      .on('event.whatsappCall', () => {
        pushGA4Event({ eventName: 'contact', eventData: { method: 'whatsapp' } });
      })
      .on('event.download', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Download',
          action: 'PDF',
          label: ['Clicked on:' + self.pageSectionAndName, $el.attr('href')].join(self.separator)
        };
        pushEvent(msg);
      })
      .on('event.clickToBE.bookNowBodyButton', function (e, el) {
        let $el = $(el);

        let msg = {
          category: 'Click to BE',
          action: 'Book Now Body Button',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        
        pushEvent(msg);
        let productInfo = getPossibleProductIDFromBookingLink($el.attr('href'));
        if (productInfo) {
          pushGA4Event({
            eventName: 'click_to_booking_engine',
            eventData: {
              link_location: `book now ${productInfo.label}`,
              product_id: productInfo.product_id
            }
          });
          return;
        }
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'book now body button'
          }
        });
      })
      .on('event.clickToBE.bookOnMaps', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Click to BE',
          action: 'Book On Maps',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);
      })
      .on('event.clickToBE.bookNowLink', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Click to BE',
          action: 'Book Now Link',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);

        let productInfo = getPossibleProductIDFromBookingLink($el.attr('href'));
        if (productInfo) {
          pushGA4Event({
            eventName: 'click_to_booking_engine',
            eventData: {
              link_location: `book now ${productInfo.label}`,
              product_id: productInfo.product_id
            }
          });
          return;
        }
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'book now link'
          }
        });
      })
      .on('event.clickToBE.loyaltyProgramPrivateOffers', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Click to BE',
          action: 'GMS Portal Private Offers',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'gms portal private offers'
          }
        });
      })
      .on('event.clickToBE.loyaltyProgramGeneralDashboard', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Click to BE',
          action: 'GMS Portal General Dashboard',
          label: [
            'Booked on:' + self.pageSectionAndName,
            $el.text().trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);

        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'gms portal general dashboard'
          }
        });
      })
      .on('event.clickToBE.loyaltyProgramBookAgain', (e, el) => {
        pushEvent({
          category: 'Click to BE',
          action: 'GMS Portal Book Again',
          label: ['Booked on:' + self.pageSectionAndName, $(el).text().trim() || 'not_applicable'].join(self.separator)
        });
        pushGA4Event({
          eventName: 'click_to_booking_engine',
          eventData: {
            link_location: 'gms portal book again'
          }
        });
      })
      .on('event.clickToBE.loyaltyProgramModifyBooking', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'Click to BE',
          action: 'GMS Modify booking',
          label: ['Booked on:' + self.pageSectionAndName, $el.text().trim() || 'not_applicable'].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({ eventName: 'user_behavior', eventData: { behavior_type: 'modify reservation guest portal' } });
      })
      .on('event.error.clickToBE', (e, el) => {
        pushEvent({
          category: 'Error',
          action: 'Click to BE',
          label: ['Clicked on:' + self.pageSectionAndName, 'error: ' + el.trim() || 'not_applicable'].join(
            self.separator
          )
        });
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'booking mask' } });
      })
      .on('bm::form::validation::failed', (e) => {
        pushEvent({
          category: 'Error',
          action: 'Click to BE',
          label: [
            'Clicked on:' + self.pageSectionAndName,
            'error: ' + e.detail.map((a) => a.message).join(' ') || 'not_applicable'
          ].join(self.separator)
        });
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'booking mask' } });
      })
      .on('event.externalLinks', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'external_links',
          action: 'social_networks',
          label: [
            'Clicked on:' + self.pageSectionAndName,
            $el.attr('href').trim() || 'not_applicable',
            calculateElementPosition($el)
          ].join(self.separator)
        };
        pushEvent(msg);
      })
      .on('event.userBehavior.backToTop', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'user_behavior',
          action: 'back_to_top',
          label: ['Clicked on:' + self.pageSectionAndName, $el.text().trim() || 'not_applicable'].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'back to top' }
        });
      })
      .on('event.userBehavior.clicksOnLogo', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'user_behavior',
          action: 'clicks_on_logo',
          label: ['Clicked on:' + self.pageSectionAndName, calculateElementPosition($el)].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'clicks on logo' }
        });
      })
      .on('event.userBehavior.detailPageNavigation', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'user_behavior',
          action: 'detail_page_navigation',
          label: [
            'Clicked on:' + self.pageSectionAndName,
            calculateElementPosition($el),
            $el.children('svg').hasClass('icon-arrow-left') ? 'previous-page' : 'next-page'
          ].join(self.separator)
        };
        pushEvent(msg);
      })
      .on('event.userBehavior.clicksOnFooterLinks', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'user_behavior',
          action: 'clicks_on_footer_links',
          label: ['Clicked on:' + self.pageSectionAndName, $el.attr('href')].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'clicks on footer links' }
        });
      })
      .on('event.userBehavior.language', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'user_behavior',
          action: 'language',
          label: ['Clicked on:' + self.pageSectionAndName, $el.data('language')].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'user_behavior',
          eventData: { behavior_type: 'change language' }
        });
      })
      .on('event.contact', function (e, el) {
        let $el = $(el);
        let msg = {
          category: 'contact',
          action: 'address',
          label: ['Clicked on: ' + self.pageSectionAndName, calculateElementPosition($el)].join(self.separator)
        };
        pushEvent(msg);
      })
      .on('event.newsletter.newSubscriber', function (e) {
        let msg = {
          category: 'Newsletter',
          action: 'New Subscriber',
          label: 'Submit Step 1'
        };
        pushEvent(msg);
      });
  },
  handleDelphiDirectEvents() {
    document.addEventListener(
      'event.delphiDirect',
      (e) => {
        if (e.detail) {
          dataLayer.push(e.detail);
        }
      },
      false
    );
  },
  handlePersonalizationPopupEvents() {
    let self = this;
    document.addEventListener(
      'event.personalization-popup.open',
      function (e) {
        const hasReadMoreLink = e.detail.dialog.querySelector('a.more-link');
        const hasButton = e.detail.dialog.querySelector('.stripe-btn-wrapper');
        pushEventNonInteraction({
          category: hasReadMoreLink || hasButton ? 'Pop-up_interactive' : 'Pop-up_non-interactive',
          action: 'Displayed',
          label: e.detail.campaign_name
        });
        pushGA4Event({
          eventName: 'pop_up',
          eventData: {
            interactive: hasReadMoreLink || hasButton ? 'yes' : 'no',
            iteraction_type: 'displayed'
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.personalization-popup.close',
      function (e) {
        const hasReadMoreLink = e.detail.dialog.querySelector('a.more-link');
        const hasButton = e.detail.dialog.querySelector('.stripe-btn-wrapper');
        pushEvent({
          category: hasReadMoreLink || hasButton ? 'Pop-up_interactive' : 'Pop-up_non-interactive',
          action: 'Close',
          label: e.detail.campaign_name
        });
        pushGA4Event({
          eventName: 'pop_up',
          eventData: {
            interactive: hasReadMoreLink || hasButton ? 'yes' : 'no',
            iteraction_type: 'closed'
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.personalization-popup.link',
      function (e) {
        pushEvent({
          category: 'Pop-up_interactive',
          action: 'Link-clicked_' + e.detail.text,
          label: e.detail.campaign_name
        });
        pushGA4Event({
          eventName: 'pop_up',
          eventData: {
            interactive: 'yes',
            iteraction_type: 'link_click',
            copy: e.detail.text
          }
        });
      },
      false
    );
  },
  handleGMSEvents() {
    let self = this;
    document.addEventListener(
      'event.loyaltyProgram.loginError',
      function (e) {
        let msg = {
          category: 'Error',
          action: 'Loyalty program log in error',
          label: ['Clicked on: ' + self.pageName, 'error: ' + e.detail].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'login on loyalty program' } });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.login',
      function (e) {
        let $el = $(e.detail);
        let platform = 'email';
        let platformGA4 = 'email';
        if ($el.is('.google')) {
          platform = 'google';
          platformGA4 = 'google';
        } else if ($el.is('.facebook')) {
          platform = 'facebook';
          platformGA4 = 'social_networks';
        } else if ($el.is('.twitter')) {
          platform = 'twitter';
          platformGA4 = 'social_networks';
        }
        let msg = {
          category: 'Loyalty program',
          action: 'Log in',
          label: ['Signed on: ' + self.pageSectionAndName, platform].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({
          eventName: 'login',
          eventData: {
            method: platformGA4
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.registerSubmit',
      function (e) {
        let msg = {
          category: 'Loyalty program',
          action: 'Register',
          label: 'Submitted OK'
        };
        pushEventNonInteraction(msg);
        pushGA4Event({
          eventName: 'sign_up',
          eventData: {
            clicked: 'submitted_ok'
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.registerError',
      function (e) {
        let msg = {
          category: 'Error',
          action: 'Loyalty program register error',
          label: ['Clicked on: ' + self.pageName, 'error: ' + e.detail].join(self.separator)
        };
        pushEvent(msg);
        pushGA4Event({ eventName: 'custom_error', eventData: { error_type: 'register on loyalty program' } });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.registerVerify',
      () => {
        pushEventNonInteraction({
          category: 'Loyalty program',
          action: 'Register',
          label: 'Double Opt-in verification OK'
        });
        pushGA4Event({
          eventName: 'sign_up',
          eventData: {
            clicked: 'registration_verified'
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.registerResend',
      () => {
        pushEvent({
          category: 'Loyalty program',
          action: 'Register',
          label: 'Resend code'
        });
        pushGA4Event({
          eventName: 'guest_portal_actions',
          eventData: {
            clicked: 'resend code'
          }
        });
      },
      false
    );
    document.addEventListener(
      'event.loyaltyProgram.registerStep1',
      function (e) {
        let msg = {
          category: 'Loyalty program',
          action: 'Register',
          label: 'Step1_clicked on: ' + self.pageName
        };
        pushEvent(msg);
      },
      false
    );

    document.addEventListener(
      'event.loyaltyProgram.registerStep2',
      function (e) {
        let msg = {
          category: 'Loyalty program',
          action: 'Register',
          label: 'Step2_clicked on: ' + self.pageName
        };
        pushEvent(msg);
      },
      false
    );
  },
  handleGMSFormEvents() {
    GMSFormEventListener(EventTracking);
  },
  handleTVSEvents() {
    TVSEventListener();
  },
  signalInit() {
    document.dispatchEvent(new CustomEvent('tc-event-tracking-ready'));
  }
};

export default {
  init: EventTracking.init,
  pushEvent,
  pushEventNonInteraction,
  pushInformation,
  fireEvent
};
